/**
 * Returns the build version to show in the menu, or null when the build carries
 * no version. The version generator writes the literal "undefined" when the
 * VERSION env var is missing (local builds), so that value is treated as absent.
 */
export function buildVersionLabel(version?: null | string): null | string {
  const value = version?.trim();

  if (!value || value === "undefined") {
    return null;
  }

  return value;
}
